import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="privacy-hero">
      <div className="privacy-hero__inner">
        <p className="privacy-hero__eyebrow">Privacy Policy</p>
        <h1 className="privacy-hero__title">We care about your privacy</h1>
        <p className="privacy-hero__text">
          Your privacy is important to us at VBS. We respect your privacy
          regarding any information we may collect from you across our website.
        </p>
      </div>
    </section>
  );
};

export default Hero;
